import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
  Contato,
  CarouselImage,
  Aviso,
  Sobre,
  Vaga,
  AuthPayload,
  Turma
} from '../models/types'

const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://cdtcc-back.onrender.com/api'
  }),
  endpoints: (builder) => ({
    getContato: builder.query<Contato, void>({
      query: () => 'contato/'
    }),
    getCarousel: builder.query<CarouselImage[], void>({
      query: () => 'carousel/'
    }),
    getAvisos: builder.query<Aviso[], void>({
      query: () => 'avisos/'
    }),
    getSobre: builder.query<Sobre, void>({
      query: () => 'sobre/dbfed782-82a1-45be-b6ac-3bec5ee6b186/'
    }),
    getVagas: builder.query<Vaga[], void>({
      query: () => 'vagas/'
    }),
    getTurmas: builder.query<Turma[], void>({
      query: () => 'turmas/'
    }),
    getTurmaById: builder.query<Turma, string>({
      query: (id) => `turmas/${id}/`
    }),
    getMe: builder.query<void, void>({
      query: () => ({
        url: '/me',
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access')}`
        }
      })
    }),
    postAuth: builder.mutation<any, AuthPayload>({
      query: (body) => ({
        url: 'token/',
        method: 'POST',
        body: body,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access')}`
        }
      })
    })
  })
})

export const {
  useGetContatoQuery,
  useGetCarouselQuery,
  useGetAvisosQuery,
  useGetSobreQuery,
  useGetVagasQuery,
  useGetMeQuery,
  useGetTurmasQuery,
  useGetTurmaByIdQuery,
  usePostAuthMutation
} = api

export default api
